import styled from 'styled-components';

export const SeasonsTable = styled.div`
  height: 800px;
  width: 100%;
  padding: 5px;
  display: flex;
  flex-direction: column;
`;
